import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ChatService } from '../../services/chat.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { SharedService } from 'src/app/services/shared.service';
import * as moment from "moment-timezone";

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit, AfterViewInit {
  chat$: Observable<any>;
  newMsg: string;
  currentVtuber: any;

  constructor(
    public cs: ChatService,
    private route: ActivatedRoute,
    public auth: AuthService,
    private shared: SharedService
  ) {}

  ngOnInit() {
    const chatId = this.route.snapshot.paramMap.get('id');
    const source = this.cs.get(chatId);
    this.chat$ = this.cs.joinUsers(source).pipe(tap(v => {
      this.scrollBottom()
      const { user, vtuber } = v
      this.shared.setCookie(SharedService.CURRENT_CHAT, { user, vtuber })
      this.currentVtuber = vtuber
    }));
  }

  ngAfterViewInit() {
    this.scrollBottom();
  }

  submit(chatId) {
    if (!this.newMsg) {
      return alert('you need to enter something');
    }
    this.cs.sendMessage(chatId, this.newMsg, false);
    this.newMsg = '';
    this.scrollBottom();
  }

  trackByCreated(i, msg) {
    return msg.createdAt;
  }

  private scrollBottom() {
    setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 500);
  }

  canReserve() {
    if (this.auth.user.role === AuthService.VTUBER_ROLE) return false;
    let stopped = false;

    this.auth.user.plans.map(item => {
      if (item.vtuber_id === this.currentVtuber.uid) {
        if (item.stoppedAt !== undefined && item.stoppedAt > 0) {
          stopped = moment(item.stoppedAt).tz('Asia/Tokyo').format("Y-MM") !== moment().tz('Asia/Tokyo').format("Y-MM")
        }
      }
    })

    return stopped === false;
  }
}